const castTypeCell = (props) => {
    const castAndCrew = props?.dataItem?.Metadata?.CastAndCrew ?? [];

    // Group cast members by role
    const grouped = {};

    for (const person of castAndCrew) {
        const role = person?.CastType?.Description?.trim();
        const name = person?.Name?.trim();
        if (role && name) {
            if (!grouped[role]) {
                grouped[role] = [];
            }
            grouped[role].push(name);
        }
    }

    // Build the JSX with bold role and names
    const displayValue = Object.entries(grouped).map(([role, names], index, array) => (
        <span key={role}>
            <strong>{role}</strong> - {names.join(', ')}
            {index !== array.length - 1 && ', '}
        </span>
    ));

    return <td>{displayValue}</td>;
};

export default castTypeCell;
